// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import gql from 'graphql-tag';

export const RECURRING_ORDERS_QUERY = gql`
  query RecurringOrdersHome(
    $todayStart: String!
  ) {
    recurring_orders(
      orderBy: [{ name: "recurring_order.customer", direction: "asc" }]
    ) {
      edges {
        node {
          id
          customer
          recurring_start_time
          recurring_end_time
          status
          recurring_options {
            exceptions
            frequencyGroups {
              frequencyType
              frequencies
            }
          }
          child_orders(
            orderBy: [
              { name: "order.order_fulfillment_time", direction: "asc" }
            ]
            filters: [
              { name: "order.order_fulfillment_time", operator: ">=", value: $todayStart }
            ]
            first: 1
          ) {
            edges {
              node {
                id
                order_fulfillment_time
              }
            }
          }
        }
      }
    }
  }
`;
